import { useContext, useEffect, useState } from 'react'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from '@mui/material'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'
import { useParams } from 'react-router-dom'
import { getDataWithParams } from 'src/consumer/services/profileService'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessful,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { toast } from 'react-toastify'
import { isValidEmail } from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import { postMPDataWithParams } from 'src/mentor/services'
import dayjs from 'dayjs'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { isInvitaionBelongingToUser, isUserLoggedIn } from './utils'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'
import { BlurredDialog } from './styledComponents'

const pageStates = {
  acceptReject: 'acceptReject',
  expired: 'expired',
  invalid: 'invalid',
  rejected: 'rejected',
  accepted: 'accepted',
}

export default function AccountInvitePage() {
  const { inviteId } = useParams()

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('signup')
  const { profileData } = useContext(ProfileContext)

  const [invitationData, setInvitationData] = useState({})
  const [invitationWrapperData, setInvitationWrapperData] = useState({})
  const [pageState, setPageState] = useState()
  const [loading, setLoading] = useState(false)
  const [showLoggedInWithOtherAccountModal, setShowLoggedInWithOtherAccountModal] = useState(false)

  async function logPageAccessed() {
    const resp = await postDataWithoutParams(
      `/api/nc/invitation/clinic-brand/open-invitation?invitation-id=${inviteId}`,
    )
    if (resp.status !== 200 || !isCommonResponseSuccessfulV2(resp)) {
      //handle error here
    }
  }

  async function getAndSetInvitationData() {
    const response = await getDataWithParams(`/api/nc/invitation/clinic-brand/get`, {
      'invitation-id': inviteId,
    })
    let pageStateToSet = pageStates.acceptReject

    if (response?.status !== 200) {
      setPageState(pageStates.invalid)
      return
    }
    if (!isCommonResponseSuccessfulV2(response)) {
      if (response?.data?.code === 4015) {
        setPageState(pageStates.expired)
        return
      }
      if (response?.data?.code === 4005) {
        setPageState(pageStates.rejected)
        return
      }
      setPageState(pageStates.invalid)
      return
    }

    if (response?.data?.code === 200) {
      pageStateToSet = pageStates.accepted
    }

    const invitationWrapper = getDataMapFromCommonResponse(response)?.['invitation-wrapper']
    const staffRequest = getDataMapFromCommonResponse(response)?.['staff-invitation-request']

    setInvitationData(staffRequest)
    setInvitationWrapperData(invitationWrapper)

    setPageState(pageStateToSet)
  }

  async function respondToInvite({ accept }) {
    if (accept === null || accept === undefined) {
      return
    }

    console.log({ profileData, invitationData, accept })

    if (!accept) {
      if (
        !isUserLoggedIn({ profileData }) ||
        !isInvitaionBelongingToUser({
          invitationData,
          profileData,
        })
      ) {
        setShowClubbedAuthModal(true)
        return
      }
    }

    if (
      !isInvitaionBelongingToUser({
        invitationData,
        profileData,
      })
    ) {
      return
    }

    setLoading(true)
    const response = await postDataWithoutParams(
      accept ? `/api/nc/invitation/clinic-brand/accept?invitation-id=${inviteId}` : `/api/secure/invitations/clinic-brand/reject?invitation-id=${inviteId}`,
      {},
    )
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      toast.success(`Invitation ${accept ? 'accpted' : 'rejected'}`)
    } else {
      toast.error(`Could not ${accept ? 'accepted' : 'rejected'} invitation`)
    }
    setLoading(false)
    await getAndSetInvitationData()
  }

  useEffect(() => {
    if (
      !isInvitaionBelongingToUser({
        invitationData,
        profileData,
      })
    ) {
      setShowLoggedInWithOtherAccountModal(true)
    } else {
      setShowLoggedInWithOtherAccountModal(false)
    }
  }, [profileData, invitationData])

  useEffect(() => {
    logPageAccessed()
    getAndSetInvitationData()
  }, [])

  useEffect(() => {
    console.log({ pageState })
  }, [pageState])

  return (
    <div>
      <PublicAppHeader
        config={{ showLinks: false, signUpButtonText: 'Create Account' }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
        showLinks={false}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
        preferredLoginInputType={isValidEmail(invitationData?.loginUsernameId) ? 'email' : 'mobile'} // mobile, email
        preferredLoginInputValue={
          invitationData?.loginUsernameId
            ? isValidEmail(invitationData?.loginUsernameId)
              ? invitationData?.loginUsernameId
              : String(invitationData?.loginUsernameId)
            : null
        } // must be string of type '+9105..' or '9105..'
      />
      {loading ? (
        <Box sx={{ width: '100%' }}>
          <LinearProgress color="secondary" />
        </Box>
      ) : (
        <div
          style={{
            width: '100%',
            padding: '0 16px',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          {pageState === pageStates.acceptReject && (
            <AcceptRejectPage
              invitationData={invitationData}
              invitationWrapperData={invitationWrapperData}
              respondToInvite={respondToInvite}
              setShowClubbedAuthModal={setShowClubbedAuthModal}
              setTypeOfClubbedAuthModal={setTypeOfClubbedAuthModal}
            />
          )}
          {pageState === pageStates.expired && <ExpiredInvalid heading="This link is expired" />}
          {pageState === pageStates.invalid && <ExpiredInvalid heading="This link is invalid" />}
          {pageState === pageStates.rejected && (
            <ExpiredInvalid heading="This invite has been rejected" />
          )}
          {pageState === pageStates.accepted && (
            <AcceptedInvite setShowClubbedAuthModal={setShowClubbedAuthModal} />
          )}

          <BlurredDialog open={showLoggedInWithOtherAccountModal}>
            <DialogTitle>Dear {profileData?.name}</DialogTitle>
            <DialogContent>
              You need to log out of your account to respond to this invitation.
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => {
                  logoutHandler()
                  window.location.reload()
                }}
              >
                Logout
              </Button>
            </DialogActions>
          </BlurredDialog>
        </div>
      )}
    </div>
  )
}

function AcceptRejectPage({
  invitationData,
  respondToInvite,
  setTypeOfClubbedAuthModal,
  setShowClubbedAuthModal,
}) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        paddingTop: '200px',
      }}
    >
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          margin: '24px auto',
        }}
      >
        <div>Invite from</div>
        <div className="text-center">
          <b>{invitationData?.clinicBrandName}</b>
        </div>
      </div>
      <div className="text-left" style={{ margin: '24px auto' }}>
        <div style={{ marginBottom: '16px' }}>Greetings {invitationData?.name}!</div>
        <div>Role: {invitationData?.roleTitle}</div>
        <div>Invited by: {invitationData?.fromName}</div>
        <div>Clinic Brand: {invitationData?.clinicBrandName}</div>
      </div>

      <div className="text-center">
        You&apos;ll be able to login to your account with{' '}
        <u>{invitationData?.loginUsernameId || '-'}</u>. Your account will be created if it does not
        exist.
      </div>

      {invitationData?.requestStatus === 'accepted' ? (
        <>
          <div className="text-center" style={{ color: 'green', marginTop: '24px' }}>
            This request has already been accepted at{' '}
            {dayjs.utc(invitationData?.responseAt).local().format('D MMM YYYY, h:mma')}. Thank you!
          </div>
          <div
            style={{ marginTop: '8px', cursor: 'pointer' }}
            onClick={() => {
              setTypeOfClubbedAuthModal('login')
              setShowClubbedAuthModal(true)
            }}
          >
            <u>Log in</u>
          </div>
        </>
      ) : (
        <div className="d-flex align-items-center justify-content-center gap-4">
          <Button
            variant="contained"
            sx={{
              margin: '24px 0',
            }}
            onClick={() => {
              respondToInvite({ accept: true })
            }}
          >
            Accept Now
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{
              margin: '24px 0',
            }}
            onClick={() => {
              respondToInvite({ accept: false })
            }}
          >
            Reject Now
          </Button>
        </div>
      )}
    </div>
  )
}

function ExpiredInvalid({ heading = '', body = '' }) {
  return (
    <div style={{ textAlign: 'center', padding: '30px 0px 0px' }}>
      {heading && <h2>{heading}</h2>}
      {body && <span>{body}</span>}
    </div>
  )
}

function AcceptedInvite({ setShowClubbedAuthModal }) {
  return (
    <div style={{ textAlign: 'center', padding: '30px 0px 0px' }}>
      <h2>This invite has been accepted</h2>
      {/* <Button
        variant="contained"
        sx={{marginTop:'10px'}}
        onClick={() => {
          setShowClubbedAuthModal(true)
        }}
      >
        Login
      </Button> */}
    </div>
  )
}
